import { Component, Input, OnDestroy, OnInit, computed, signal } from '@angular/core';
import { Subscription } from 'rxjs';

import { PlayerSizeDetectionService } from './PlayerSizeDetection.Service';
import { SubtitleService } from './Subtitle.Service';
import { VideogularComponent } from './videogular/Videogular.Component';

const BASE_FONT_RATIO = 0.07;

@Component({
	selector: 'vb-subtitle-display',
	host: {
		'[class.controlsVisible]': 'areControlsVisible',
		'[class.smallSizePlayer]': 'isSmallSizePlayer'
	},
	template: `
		@if (vgApi.isHtmlSubtitleRenderingEnabled && vgApi.currentSubtitle) {
			<div
				class="subtitles"
				[ngStyle]="subtitleCssVariables()"
				[innerHTML]="vgApi.currentSubtitle">
			</div>
		}
	`,
	standalone: false,
	styleUrls: ['./VbSubtitleDisplay.Component.ng.less']
})
export class VbSubtitleDisplayComponent implements OnDestroy, OnInit {
	@Input() public areControlsVisible: boolean;
	@Input() public isSmallSizePlayer: boolean;

	private subscription: Subscription = new Subscription();
	private readonly playerSize = signal({ height: 0, width: 0 });

	public readonly subtitleCssVariables = computed(() => {
		const options = this.SubtitleService.subtitleOptions();
		const { width, height } = this.playerSize();
		const responsiveFontSize = this.getResponsiveFontSize(options.fontSize, width, height);

		return {
			'--vb-subtitle-background-color': options.backgroundColor,
			'--vb-subtitle-background-opacity': `${options.backgroundOpacity}`,
			'--vb-subtitle-font-color': options.fontColor,
			'--vb-subtitle-font-size': `${responsiveFontSize}px`
		};
	});

	constructor(
		private readonly PlayerSizeDetectionService: PlayerSizeDetectionService,
		private readonly SubtitleService: SubtitleService,
		public vgApi: VideogularComponent
	) { }

	public ngOnInit(): void {
		this.subscription.add(
			this.PlayerSizeDetectionService.screenSizeSubject$.subscribe(size => this.playerSize.set(size))
		);
	}

	public ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	private getResponsiveFontSize(userFontSize: number, playerWidth: number, playerHeight: number): number {
		if (!playerHeight) {
			return 21;
		}

		userFontSize = userFontSize ?? 1;
		const baseFontSize = playerHeight * BASE_FONT_RATIO;

		let fontSize = baseFontSize * userFontSize;
		fontSize = Math.max(12, fontSize);

		if (playerWidth) {
			fontSize = Math.min(fontSize, playerWidth * 0.08);
		}

		return Math.round(fontSize * 100) / 100;
	}
}
